<div class="f-wrapper mb-xl-9" ng-cloak>
  <eb-navbar> </eb-navbar>
  <main>
    <router-outlet></router-outlet>
  </main>
  <eb-footer> </eb-footer>
</div>

<eb-spinner> </eb-spinner>
